import React from "react";
import Head from "next/head";

import seoData from "@/data/seo/page-data.json";
import SeoMetaData from "@/components/utils/seo-metadata";
import PurolatorMain from "@/components/fulfilment-partners/purolator-main";

const USPSPartner = () => {
  return (
    <>
      <Head>
        <title>{seoData.PARTNER.title}</title>
        <SeoMetaData data={seoData.PARTNER} />
      </Head>

      <PurolatorMain />
    </>
  );
};

export default USPSPartner;
